import React from 'react'
import { Container } from 'react-bootstrap'
import QuestionsImg from '../assets/images/questions-cta-img.svg'
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function QuestionsCTA({ data, loading }) {
  return (
    <>
      <div className="questions-cta common-padding">
        <Container>
          <div className='questions-cta-wrap'>
            <img src={`${BASE_URL}${data?.icon}`} alt="" />
            <div className='text-wrap'>
              <h2>{data?.title || ""}</h2>
              <p>{data?.subtitle || ""}</p>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}
export default QuestionsCTA